<template>
  <div class="content if-profile report-tab">
    <div class="md-layout finanical-insights-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <CRHeader :headerData="this.headerData"/>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0 mt-4">
          <h1 class="section_header">Insights</h1>
          <div class="md-toolbar-row fundamentals_wpr cr_financial p-0">
            <nav-tabs-card>
              <template slot="content">
                <md-tabs md-alignment="left" class="p-0">
                  <md-tab
                    id="tab-financial-insights"
                    md-label="Industry Financial Insights"
                    md-icon="developer_board"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <div class="md-layout">
                        <div class="md-layout-item p-0">
                          <md-card class="m-0">
                            <md-card-header>
                              Industry Financial Insights <span class="info">{{ period }}</span>
                            </md-card-header>
                            <md-card-content>
                              <div class="md-layout">
                                <div class="md-layout-item p-0">
                                  <div class="tbldata_info">Financial Metrics: Sales Class: {{ salesClass }} <!--(Peer industry and sales class average % basis)--></div>
                                </div>
                                <div class="md-layout-item md-medium-size-100 md-size-100 p-0" v-if="spend">
                                  <md-table
                                    v-model="spend"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Benchmarks">
                                          {{ item.name }}
                                      </md-table-cell>
                                       <md-table-cell md-label="Industry">
                                        {{ item.percentage }}
                                      </md-table-cell>
                                      <md-table-cell md-label="Firm">
                                        {{ item.firm }}
                                      </md-table-cell>
                                     
                                    </md-table-row>
                                  </md-table>
                                </div>
                                <div class="md-layout-item md-medium-size-100 md-size-100 p-0" v-if="benchmarks">
                                  <md-table
                                    v-model="benchmarks"
                                    table-header-color="blue"
                                    class="profit-and-loss-table"
                                  >
                                    <md-table-row
                                      slot="md-table-row"
                                      slot-scope="{ item }"
                                    >
                                      <md-table-cell md-label="Industry Standard Benchmarks">
                                        {{ item.name }}
                                      </md-table-cell>
                                      <md-table-cell md-label="Industry">
                                        {{ item.ratio }}
                                      </md-table-cell>
                                      <md-table-cell md-label="Firm">
                                        {{ item.firm }}
                                      </md-table-cell>                                      
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>      
                      </div>
                    </div>
                  </md-tab>
                  <md-tab
                    id="tab-market-insights"
                    md-label="Industry Market Insights"
                    md-icon="pie_chart"
                    class="p-0"
                  >
                    <div class="md-toolbar-row fundamentals_area p-0">
                      <CRMarketInsights/>
                    </div>
                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
           <!-- <div class="extra_info_area">
              <md-card>
                <md-card-header><md-icon>account_balance</md-icon>Curabitur Eleifend</md-card-header>
                <md-card-content>
                  <h4>Praesent venenatis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card> -->
             <!-- <md-card>
                <md-card-header><md-icon>vertical_split</md-icon>Vivamus Hendrerit</md-card-header>
                <md-card-content>
                  <h4>Fusce feugiat mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Praesent eget sem eget</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card> -->
             <!-- <md-card>
                <md-card-header><md-icon>article</md-icon>Gravida Pharetra</md-card-header>
                <md-card-content>
                  <h4>Aenean at eros mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card> 
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapActions, mapState } from 'vuex';
import CRHeader from './CRHeader.vue';
import CRMarketInsights from './CRMarketInsights.vue'

export default {
  components: {
    //ChartCard,
    NavTabsCard,
    CRHeader,
    CRMarketInsights
  },
  props:['headerData'],
  data() {
    return {
      pieChart: {
        data: {
          labels: ['42%', '20%', '28%', '6%', '4%'],
          series: [42, 20, 28, 6, 4],
        },
        options: {
          height: '250px',
        },
      },
    };
  },
  computed: {
    user(){
      return this.$store.state.user.user;
    },
    companyReportSummary() {
      return this.$store.getters['user/companyReport'];
    },
    companyReportReleaseDisplay() {
      return this.$store.getters.companyReportReleaseDisplay;
    },
    period() {
      return this.companyReportSummary
        ? this.companyReportSummary['IF']['period']
        : '';
    },
    salesClass() {
      return this.companyReportSummary
        ? this.companyReportSummary['IF']['sales-class']
        : '';
    },
    spend() {
      return this.companyReportSummary
        ? Object.keys(this.companyReportSummary['IF']['spend']).map((key) => {
            return {
              name: key,
              dollar: this.companyReportSummary['IF']['spend'][key]['dollar'],
              firm: this.companyReportSummary['IF']['spend'][key]['firm'],
              percentage: this.companyReportSummary['IF']['spend'][key][
                'percentage'
              ],
            };
          })
        : null;
    },
    benchmarks() {
      return this.companyReportSummary
        ? Object.keys(this.companyReportSummary['IF']['benchmarks']).map(
            (key) => {
              return {
                name: key,
                firm: this.companyReportSummary['IF']['benchmarks'][key][
                  'firm'
                ],
                ratio: this.companyReportSummary['IF']['benchmarks'][key][
                  'ratio'
                ],
              };
            }
          )
        : null;
    },
  },
  methods: {
    // ...mapState({
    //   companyReport: (state) => state.user.company_report,
    // }),
    companyReport() {
      return this.$store.getters['user/companyReport'];
    },
  },
};
</script>
<style lang="scss">
.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.industry-insights-table {
  display: flex;
  align-items: flex-start;
}
</style>
